import { render, staticRenderFns } from "./package-merge.vue?vue&type=template&id=d35b3236&scoped=true"
import script from "./package-merge.vue?vue&type=script&lang=tsx"
export * from "./package-merge.vue?vue&type=script&lang=tsx"
import style0 from "./package-merge.vue?vue&type=style&index=0&id=d35b3236&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35b3236",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d35b3236')) {
      api.createRecord('d35b3236', component.options)
    } else {
      api.reload('d35b3236', component.options)
    }
    module.hot.accept("./package-merge.vue?vue&type=template&id=d35b3236&scoped=true", function () {
      api.rerender('d35b3236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/warehouse/inbound/package-merge.vue"
export default component.exports